import axios from '../helpers/Axios'

export default {
  async getCallUrl(details) {
    return await axios.post("/call/getCallUrl", details);
  },
  async initiate(details) {
    return await axios.post("/call/initiate", details, { timeout: 1000 * 15 });
  },
  async getRingCentralUserCallerIds() {
    return await axios.get("/call/getRingCentralUserCallerIds", { timeout: 1000 * 120 });
  },
  async updateUserDefaultCallerId(callerId) {
    return await axios.get("/call/updateUserCallerId/" + callerId, { timeout: 1000 * 120 });
  },
  async getDialPadCallerIds() {
    return await axios.get("/call/getDialPadCallerIds", { timeout: 1000 * 120 });
  },
  async updateUserDialPadCallerId(callerId) {
    return await axios.post("/call/updateUserDialPadCallerId", { callerId }, { timeout: 1000 * 120 });
  },
  async enableCallButtons() {
    return await axios.get("/call/enableCallButtons", { timeout: 1000 * 120 });
  },
  async userDefaultCallerId() {
    return await axios.get("/call/userDefaultCallerId", { timeout: 1000 * 120 });
  },
}
